<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <div>
    <h4 class="modal-title d-inline-block">
      <span>{{ 'MEDIA_LIBRARY.TITLE' | translate }} </span>
    </h4>

    <form [formGroup]="searchForm" class="d-inline-block">
      <input
        type="text"
        class="search-input"
        formControlName="keyword"
        [placeholder]="'MEDIA_LIBRARY.FILTER' | translate"
      />
    </form>
  </div>

  <div>
    <div class="d-inline-block">
      <!--      <button type="button" class="btn btn-upload">-->
      <!--        <i class="fas fa-upload"></i>-->
      <!--        {{ 'MEDIA_LIBRARY.UPLOAD' | translate }}-->
      <!--      </button>-->

      <p-fileUpload
        [styleClass]="'btn btn-upload display-flex-btn'"
        [chooseLabel]="'MEDIA_LIBRARY.UPLOAD' | translate"
        [chooseIcon]="'pi pi-upload'"
        [accept]="acceptType"
        #fileUploader
        name="files[]"
        [multiple]="true"
        [auto]="true"
        [showUploadButton]="false"
        [showCancelButton]="false"
        customUpload="true"
        (uploadHandler)="upload($event, fileUploader)"
        mode="basic"
      ></p-fileUpload>
    </div>

    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
    </button>
  </div>
</div>

<ng-scrollbar class="modal-body ps">
  <div class="d-flex flex-nowrap">
    <div class="images-wrapper" [ngClass]="{ 'w-100': !fileForPreview }">
      <div class="row">
        <div class="col-sm-2" *ngFor="let media of filteredMedia">
          <div class="single-item-wrapper" [ngClass]="{ selected: findFileIndex(media.id) > -1 }">
            <div
              class="top file"
              [ngClass]="media.mime_type.split('/')[0]"
              [ngStyle]="{
                'background-image':
                  'url(' +
                  (media?.conversions?.thumbnail ? media?.conversions?.thumbnail : media?.conversions?.original) +
                  ')'
              }"
            >
              <div class="checkbox-holder">
                <input (change)="fileCheckboxChange(media)" [checked]="isFileSelected(media.id)" type="checkbox" />
              </div>

              <button
                (click)="filePreview(media)"
                type="button"
                class="btn btn-warning btn-ico btn-preview"
                [ngbTooltip]="'MEDIA_LIBRARY.PREVIEW' | translate"
                container="body"
              >
                <i class="fal fa-expand-alt"></i>
              </button>

              <app-delete-button [swal]="{}" (confirm)="delete(media)" class="app-delete-button"></app-delete-button>
            </div>

            <div class="file-bottom">
              <div class="file-name" [ngbTooltip]="media?.name" container="body">
                {{ media?.name }}
              </div>

              <div class="additional-info d-flex justify-content-between">
                <div class="id">ID: {{ media.id }}</div>
                <span>{{ media.size | filesize }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="mediaData?.data?.length <= 0" class="modal-section-title">
        {{ 'MEDIA_LIBRARY.NO_FILES_MSG' | translate }}
      </div>

      <p-paginator
        *ngIf="mediaData && mediaData.meta && mediaData.data"
        [rows]="mediaData.meta.per_page"
        [totalRecords]="mediaData.meta.total"
        (onPageChange)="paginate($event)"
      ></p-paginator>
    </div>

    <div class="preview" *ngIf="fileForPreview">
      <div class="text-end mb-3">
        <button class="btn btn-danger btn-ico" type="button" (click)="closeFilePreview()">
          <i class="fal fa-times"></i>
        </button>
      </div>
      <img
        [src]="
          fileForPreview?.conversions?.thumbnail
            ? fileForPreview?.conversions?.thumbnail
            : fileForPreview?.conversions?.original
        "
        class="img-fluid preview-img"
        *ngIf="fileForPreview.mime_type.split('/')[0] == 'image'"
      />

      <div *ngIf="fileForPreview.mime_type.split('/')[0] !== 'image'">coming soon</div>

      <div class="form-group">
        <label>{{ 'MEDIA_LIBRARY.NAME' | translate }}</label>
        <input
          class="form-control mb-0"
          type="text"
          [(ngModel)]="fileForPreview.name"
          [ngModelOptions]="{ standalone: true }"
        />
        <div class="text-end">
          <small class="btn btn-xs btn-primary" (click)="updateMedia(fileForPreview)">
            {{ 'MEDIA_LIBRARY.UPDATE_FILE' | translate }}
          </small>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-sm-6">
          <div class="title">{{ 'MEDIA_LIBRARY.CREATED_AT' | translate }}</div>
          {{ fileForPreview.created_at.getDate() }}
        </div>
        <div class="col-sm-6">
          <div class="title">{{ 'MEDIA_LIBRARY.SIZE' | translate }}</div>
          {{ fileForPreview.size | filesize }}
        </div>

        <div class="col-sm-12">
          <div class="title">{{ 'MEDIA_LIBRARY.UPLOADER' | translate }}</div>
          {{ fileForPreview?.user?.fake_first_name }} {{ fileForPreview?.user?.fake_last_name }}
        </div>
      </div>

      <div class="mt-3" *ngIf="localesFeature">
        <div class="title">{{ 'MEDIA_LIBRARY.VISIBILITY' | translate }}</div>
        <div
          *ngFor="let websiteLocale of fileForPreview?.meta_front?.locales"
          class="website-locale d-flex align-items-center"
        >
          <div class="me-1">
            <input
              type="checkbox"
              id="websiteLocale-{{ websiteLocale.id }}"
              [(ngModel)]="websiteLocale.state"
              [ngModelOptions]="{ standalone: true }"
              [value]="1"
            />
          </div>
          <label class="name" for="websiteLocale-{{ websiteLocale.id }}">
            {{ websiteLocale.website.url }}
          </label>
          <div class="flag ms-auto">
            <span class="flag-icon" [ngClass]="'flag-icon-' + websiteLocale.locale.locale"></span>
          </div>
        </div>

        <div class="text-end">
          <small class="btn btn-xs btn-primary" (click)="updateMedia(fileForPreview)">
            {{ 'MEDIA_LIBRARY.UPDATE_FILE' | translate }}
          </small>
        </div>
      </div>
    </div>
  </div>
  <!--  <p-fileUpload-->
  <!--    [styleClass]="'btn btn-upload'"-->
  <!--    #fileUploader-->
  <!--    name="files[]"-->
  <!--    [multiple]="true"-->
  <!--    [auto]="true"-->
  <!--    [showUploadButton]="false"-->
  <!--    [showCancelButton]="false"-->
  <!--    [accept]="acceptType"-->
  <!--    customUpload="true"-->
  <!--    (uploadHandler)="upload($event, fileUploader)"-->
  <!--    mode="basic"-->
  <!--  ></p-fileUpload>-->
</ng-scrollbar>

<div class="modal-footer justify-content-between">
  <div class="d-flex">
    <button type="button" class="btn btn-outline-primary btn-xs me-1" (click)="selectAllFilesOnPage()">
      <i class="fas fa-check-double"></i> {{ 'MEDIA_LIBRARY.SELECT_ALL_IN_PAGE' | translate }}
    </button>

    <button type="button" class="btn btn-outline-danger btn-xs me-1" (click)="deSelectAllFiles()">
      <i class="fas fa-times"></i> {{ 'MEDIA_LIBRARY.DESELECT_ALL' | translate }}
    </button>

    <div *ngIf="selectedFiles.length > 0">
      <button type="submit" class="btn btn-outline-danger btn-xs" [swal]="{}" (confirm)="deleteMultiple()">
        <i class="fas fa-trash"></i> {{ 'MEDIA_LIBRARY.DELETE_ALL' | translate }}
      </button>

      <button type="submit" class="btn btn-outline-secondary btn-xs" (click)="downloadMultiple()">
        <i class="fas fa-download"></i> {{ 'MEDIA_LIBRARY.DOWNLOAD_ALL' | translate }}
      </button>

      <strong>
        {{ 'MEDIA_LIBRARY.SELECTED_FILES_COUNT' | translate : '{ count: ' + selectedFiles.length + ' }' }}
      </strong>
    </div>
  </div>

  <div>
    <button (click)="modal.dismiss()" class="btn btn-outline-dark btn-xs">
      {{ 'MEDIA_LIBRARY.CLOSE' | translate }}
    </button>
  </div>
</div>
